module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-192x192-bccb9979e7b5105c0130883c84dbcaf9.png";